var map = {
	"./AUTHORIZATION_LETTER.png": "5685",
	"./BACHELOR_DEGREE.png": "3c63",
	"./CAS_BRP.png": "6771",
	"./CV.png": "d151",
	"./DSE_TRANSCRIPT.png": "efca",
	"./GRADUATION_CERTIFICATE.png": "9cd8",
	"./INTERNSHIP_CERTIFICATE.png": "d049",
	"./OTHERS.png": "82d9",
	"./PASSPORT.png": "7290",
	"./PS.png": "c8cd",
	"./REFERENCE_LETTER_1.png": "31f7",
	"./REFERENCE_LETTER_2.png": "10c8",
	"./STUDY_CERTIFICATE.png": "bc5a",
	"./TOEFL.png": "95f1",
	"./TRANSCRIPT.png": "8234"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "21ee";